import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "_pa-2" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_themed_image = _resolveComponent("themed-image")
  const _component_base_compare_row = _resolveComponent("base-compare-row")
  const _component_base_icon = _resolveComponent("base-icon")
  const _component_base_badge = _resolveComponent("base-badge")
  const _component_base_compare_table = _resolveComponent("base-compare-table")
  const _component_box = _resolveComponent("box")

  return (_openBlock(), _createBlock(_component_box, {
    content: "",
    class: "_ov-h"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_base_compare_table, {
          "primary-label": $options.platformName,
          "secondary-label": "Kickstarter"
        }, {
          default: _withCtx(() => [
            (!$options.isMobile)
              ? (_openBlock(), _createBlock(_component_base_compare_row, {
                  key: 0,
                  highlighted: "none"
                }, {
                  primary: _withCtx(() => [
                    _createVNode(_component_themed_image, {
                      src: "/content/images/static/logo/site-logo.svg",
                      height: "20",
                      alt: $options.platformName
                    }, null, 8 /* PROPS */, ["alt"])
                  ]),
                  secondary: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                    _createElementVNode("strong", null, "Kickstarter", -1 /* CACHED */)
                  ]))]),
                  _: 1 /* STABLE */
                }))
              : _createCommentVNode("v-if", true),
            _createVNode(_component_base_compare_row, { first: "" }, {
              label: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                _createTextVNode("Number of Payment Methods", -1 /* CACHED */)
              ]))]),
              primary: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                _createTextVNode("21", -1 /* CACHED */)
              ]))]),
              secondary: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                _createTextVNode("5", -1 /* CACHED */)
              ]))]),
              _: 1 /* STABLE */
            }),
            _createVNode(_component_base_compare_row, null, {
              label: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                _createTextVNode("Currency Conversion", -1 /* CACHED */)
              ]))]),
              primary: _withCtx(() => [
                _createVNode(_component_base_icon, {
                  name: "check",
                  size: "lg",
                  class: "_tc--accent"
                })
              ]),
              secondary: _withCtx(() => [
                _createVNode(_component_base_icon, {
                  name: "times",
                  size: "lg"
                })
              ]),
              _: 1 /* STABLE */
            }),
            _createVNode(_component_base_compare_row, null, {
              label: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                _createTextVNode("Availability of Installments", -1 /* CACHED */)
              ]))]),
              primary: _withCtx(() => [
                _createElementVNode("div", null, [
                  _createVNode(_component_themed_image, {
                    src: "/content/images/static/stretch-pay/installments-logo.svg",
                    alt: "strechPay",
                    height: "16"
                  })
                ]),
                _cache[6] || (_cache[6] = _createElementVNode("span", { class: "gfu-bt gfu-bt--caption" }, "available during Crowdfunding, Late Pledge, and Pledge Manager", -1 /* CACHED */))
              ]),
              secondary: _withCtx(() => [...(_cache[7] || (_cache[7] = [
                _createElementVNode("div", null, "Pledge Over Time", -1 /* CACHED */),
                _createElementVNode("span", { class: "gfu-bt gfu-bt--caption" }, "available during Crowdfunding only", -1 /* CACHED */)
              ]))]),
              _: 1 /* STABLE */
            }),
            _createVNode(_component_base_compare_row, null, {
              label: _withCtx(() => [...(_cache[8] || (_cache[8] = [
                _createTextVNode("Flexibility of Installments", -1 /* CACHED */)
              ]))]),
              primary: _withCtx(() => [...(_cache[9] || (_cache[9] = [
                _createTextVNode("Customizable number of installments and minimum order value", -1 /* CACHED */)
              ]))]),
              secondary: _withCtx(() => [...(_cache[10] || (_cache[10] = [
                _createTextVNode("3 fixed installments, minimum order value of $125", -1 /* CACHED */)
              ]))]),
              _: 1 /* STABLE */
            }),
            _createVNode(_component_base_compare_row, null, {
              label: _withCtx(() => [...(_cache[11] || (_cache[11] = [
                _createTextVNode("Tax Charging", -1 /* CACHED */)
              ]))]),
              primary: _withCtx(() => [...(_cache[12] || (_cache[12] = [
                _createTextVNode("During Crowdfunding, Late Pledge, and Pledge Manager", -1 /* CACHED */)
              ]))]),
              secondary: _withCtx(() => [...(_cache[13] || (_cache[13] = [
                _createTextVNode("Only in Pledge Manager", -1 /* CACHED */)
              ]))]),
              _: 1 /* STABLE */
            }),
            _createVNode(_component_base_compare_row, null, {
              label: _withCtx(() => [...(_cache[14] || (_cache[14] = [
                _createTextVNode("Performance Marketing Support", -1 /* CACHED */)
              ]))]),
              primary: _withCtx(() => [...(_cache[15] || (_cache[15] = [
                _createTextVNode("Internal team & Adfound", -1 /* CACHED */)
              ]))]),
              secondary: _withCtx(() => [...(_cache[16] || (_cache[16] = [
                _createTextVNode("Internal team", -1 /* CACHED */)
              ]))]),
              _: 1 /* STABLE */
            }),
            _createVNode(_component_base_compare_row, { highlighted: "both" }, {
              label: _withCtx(() => [...(_cache[17] || (_cache[17] = [
                _createTextVNode("Mobile App", -1 /* CACHED */)
              ]))]),
              primary: _withCtx(() => [
                _createVNode(_component_base_badge, { theme: "accent" }, {
                  default: _withCtx(() => [...(_cache[18] || (_cache[18] = [
                    _createTextVNode("Coming soon", -1 /* CACHED */)
                  ]))]),
                  _: 1 /* STABLE */
                })
              ]),
              secondary: _withCtx(() => [
                _createVNode(_component_base_icon, {
                  name: "check",
                  size: "lg",
                  class: "_tc--accent"
                })
              ]),
              _: 1 /* STABLE */
            }),
            _createVNode(_component_base_compare_row, null, {
              label: _withCtx(() => [...(_cache[19] || (_cache[19] = [
                _createTextVNode("Endgame (crowdfunding campaign extension)", -1 /* CACHED */)
              ]))]),
              primary: _withCtx(() => [
                _createVNode(_component_base_icon, {
                  name: "check",
                  size: "lg",
                  class: "_tc--accent"
                })
              ]),
              secondary: _withCtx(() => [
                _createVNode(_component_base_icon, {
                  name: "times",
                  size: "lg"
                })
              ]),
              _: 1 /* STABLE */
            }),
            _createVNode(_component_base_compare_row, null, {
              label: _withCtx(() => [...(_cache[20] || (_cache[20] = [
                _createTextVNode("Express crowdfunding", -1 /* CACHED */)
              ]))]),
              primary: _withCtx(() => [
                _createVNode(_component_base_icon, {
                  name: "check",
                  size: "lg",
                  class: "_tc--accent"
                })
              ]),
              secondary: _withCtx(() => [
                _createVNode(_component_base_icon, {
                  name: "times",
                  size: "lg"
                })
              ]),
              _: 1 /* STABLE */
            }),
            _createVNode(_component_base_compare_row, null, {
              label: _withCtx(() => [...(_cache[21] || (_cache[21] = [
                _createTextVNode("Shipping Options in Pledge Manager", -1 /* CACHED */)
              ]))]),
              primary: _withCtx(() => [...(_cache[22] || (_cache[22] = [
                _createTextVNode("Multiple advanced models (by weight, quantity, and more)", -1 /* CACHED */)
              ]))]),
              secondary: _withCtx(() => [...(_cache[23] || (_cache[23] = [
                _createTextVNode("Limited options", -1 /* CACHED */)
              ]))]),
              _: 1 /* STABLE */
            }),
            _createVNode(_component_base_compare_row, null, {
              label: _withCtx(() => [...(_cache[24] || (_cache[24] = [
                _createTextVNode("Homepage Project Visibility", -1 /* CACHED */)
              ]))]),
              primary: _withCtx(() => [...(_cache[25] || (_cache[25] = [
                _createTextVNode("Across all phases (Crowdfunding, Late Pledge, and Pledge Manager) ", -1 /* CACHED */)
              ]))]),
              secondary: _withCtx(() => [...(_cache[26] || (_cache[26] = [
                _createTextVNode("Limited to Crowdfunding", -1 /* CACHED */)
              ]))]),
              _: 1 /* STABLE */
            })
          ]),
          _: 1 /* STABLE */
        }, 8 /* PROPS */, ["primary-label"])
      ])
    ]),
    _: 1 /* STABLE */
  }))
}